import React from 'react';
import PromptBar from '../../../components/primitives/PromptBar';

interface ChatInputProps {
  onSend: (message: string) => void;
  isLoading: boolean;
  onStop?: () => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSend, isLoading, onStop }) => {
  return (
    <div className="bg-white border-t border-gray-100 p-3 sm:p-4 pb-5 sm:pb-6">
      <div className="w-full max-w-5xl xl:max-w-6xl mx-auto">
        <div className="relative group">
          <div className="pointer-events-none absolute -inset-x-[3px] -top-[3px] -bottom-[6px] bg-gradient-to-r from-[#3B3E81] to-[#E23338] rounded-[16px] blur-[5px] opacity-30 group-focus-within:opacity-55 transition duration-300" />
          <div className="relative">
            <PromptBar
              variant="Rounded"
              demo={false}
              gradient={true}
              placeholder="Message MRC AI…"
              onSend={onSend}
              onStop={onStop}
              isLoading={isLoading}
            />
          </div>
        </div>

        <div className="mt-2 flex items-center justify-between px-1 text-[11px] text-gray-400">
          <span className="truncate">AI can make mistakes. Please verify important information.</span>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;
